import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { requestID, baseUrl, config } from "../../../common/utils";
import { useQuery } from "react-query";
import axios from "axios";
import styles from "./InventoryUsage.module.css";
import { IonContent, IonHeader, IonPage } from "@ionic/react";

const InventoryUsageReport: React.FC = () => {
  const [startDate, setStartDate] = useState<Dayjs | null>(
    dayjs().subtract(7, "day")
  );
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  //   const totalUsed = mockInventoryData.reduce((acc, item) => acc + item.quantityUsed, 0);
  // const [startDate, setStartDate] = useState<Dayjs | null>(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null);

  const inventory2 = async () => {
    const payload = {
      startDate: startDate?.format("YYYY-MM-DD"),
      endDate: endDate?.format("YYYY-MM-DD"),
      requestID: requestID(),
    };
    const response = await axios.post(
      `${baseUrl()}warehouses/warehouse_inventory_usage`,
      payload,
      config
    );

    if (data) {
      console.log("Inventory data in component:", data);
    }
    console.log("Inventory data:", response.data.data);
    return response.data.data;
  };

  const { data, isLoading, error } = useQuery("inventoryData", inventory2, {
    refetchOnWindowFocus: true,
    retry: true,
    onError: (error) => {
      console.error("Error fetching inventory data:", error);
    },
  });

  type item = {
    vendor_id: string;
    productName: string;
    total_quantity_consumed: number;
    total_quantity_left: number;
    total_quantity_supplied: number;
    unit_price: number;
    productCategory: string;
    dateCreated: string;
  };

  const groupedData: Record<string, item[]> = (data || []).reduce(
    (acc, item) => {
      const vendor = item.vendor_id || "Unknown Vendor";
      if (!acc[vendor]) {
        acc[vendor] = [];
      }
      acc[vendor].push(item);
      return acc;
    },
    {} as Record<string, any[]>
  );

  const LoadingSkeleton = () => (
    <>
      {[1, 2].map((vendor) => (
        <Box key={vendor} className={styles.skeletonContainer}>
          <Skeleton
            variant="text"
            width={200}
            height={32}
            className={`${styles.skeleton} ${styles.skeletonVendor}`}
          />

          <TableContainer component={Paper} className={styles.tableContainer}>
            <Table>
              <TableHead className={styles.tableHead}>
                <TableRow>
                  <TableCell className={styles.tableHeadCell}>Date</TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Product
                  </TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Quantity Used
                  </TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Quantity Left
                  </TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Quantity Supplied
                  </TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Unit Price
                  </TableCell>
                  <TableCell className={styles.tableHeadCell}>
                    Category
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {[1, 2, 3, 4, 5].map((row) => (
                  <TableRow key={row} className={styles.tableRow}>
                    {[1, 2, 3, 4, 5, 6, 7].map((cell) => (
                      <TableCell key={cell} className={styles.tableCell}>
                        <Skeleton variant="text" className={styles.skeleton} />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </>
  );

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
      <Typography variant="h5" gutterBottom className={styles.title}>
        INVENTORY USAGE REPORT
      </Typography>
      </IonHeader>



<IonContent>


    <Box p={3} className={styles.container}>
   

      <Grid container spacing={2} mb={3} className={styles.dateFilterContainer}>
        <Grid item xs={12} md={12}>
          <Box display="flex" gap={2}>
            <TextField
              label="Start Date"
              type="date"
              fullWidth
              value={startDate?.format("YYYY-MM-DD")}
              onChange={(e) => setStartDate(dayjs(e.target.value))}
              InputLabelProps={{ shrink: true }}
              className={styles.textField}
            />
            <TextField
              label="End Date"
              type="date"
              fullWidth
              value={endDate?.format("YYYY-MM-DD")}
              onChange={(e) => setEndDate(dayjs(e.target.value))}
              InputLabelProps={{ shrink: true }}
              className={styles.textField}
            />
          </Box>
        </Grid>
      </Grid>

      {isLoading ? (
        <LoadingSkeleton />
      ) : error ? (
        <Typography className={styles.errorText}>Error loading data</Typography>
      ) : (
        Object.entries(groupedData).map(([vendorId, items]) => (
          <Box key={vendorId} mb={4} className={styles.vendorSection}>
            <Typography
              variant="h6"
              gutterBottom
              className={styles.vendorTitle}
            >
              {vendorId}
            </Typography>

            <TableContainer component={Paper} className={styles.tableContainer}>
              <Table>
                <TableHead className={styles.tableHead}>
                  <TableRow>
                    <TableCell className={styles.tableHeadCell}>Date</TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Product
                    </TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Quantity Used
                    </TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Quantity Left
                    </TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Quantity Supplied
                    </TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Unit Price
                    </TableCell>
                    <TableCell className={styles.tableHeadCell}>
                      Category
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items
                    .filter((item) => {
                      const itemDate = dayjs(item.dateCreated).format(
                        "YYYY-MM-DD"
                      );
                      const start = startDate?.format("YYYY-MM-DD");
                      const end = endDate?.format("YYYY-MM-DD");
                      return itemDate >= start && itemDate <= end;
                    })
                    .map((item, index) => (
                      <TableRow key={index} className={styles.tableRow}>
                        <TableCell className={styles.tableCell}>
                          {dayjs(item.dateCreated).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.productName}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.total_quantity_consumed}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.total_quantity_left}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.total_quantity_supplied}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.unit_price}
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          {item.productCategory}
                        </TableCell>
                      </TableRow>
                    ))}
                  {items.filter((item) => {
    const itemDate = dayjs(item.dateCreated).format("YYYY-MM-DD");
    const start = startDate?.format("YYYY-MM-DD");
    const end = endDate?.format("YYYY-MM-DD");
    return itemDate >= start && itemDate <= end;
  }).length === 0 && (
    <TableRow>
      <TableCell colSpan={7} align="center" className={styles.noDataCell}>
        No data available for selected dates
      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ))
      )}
    </Box>
      
    </IonContent>
    </IonPage>

  );
};

export default InventoryUsageReport;
